export default __webpack_public_path__ + "static/region-hero-cb42e9fec3153bbcbea4e3f8f3b858dc.jpg";